import denomination from 'support/helpers/denomination'

export default function (id, name, price, quantity) {
  const format = denomination

  if (window.dataLayer) {
    window.dataLayer.push({
      event: 'addToCart',
      ecommerce: {
        currencyCode: 'DKK',
        add: {
          products: [{
            name: name,
            id: id,
            price: format(price),
            quantity: quantity
          }]
        }
      }
    })
  }
}
